import { useMatomo } from '@datapunt/matomo-tracker-react';
import React, { useEffect } from 'react';

import Onboarding from '@components/Onboarding/Onboarding';
import Header from '@components/common/Header/Header';

import useTranslation from '@hooks/useTranslation';

import { getOnboardSteps } from '@pages/Reports/helpers/getOnboardSteps';

import { useUserProfileQuery } from '@services/user/useUserProfileQuery';

import { selectAppPersistOnBoardStart } from '@store/useAppStorePersist';

import Report from './components/Report/Report';
import { REPORT_ACTIONS } from './constants/reportActions';
import style from './style.module.scss';

const Reports = () => {
  const onBoardStart = selectAppPersistOnBoardStart();
  const { trackPageView } = useMatomo();
  const { data: profileData } = useUserProfileQuery();
  const { t } = useTranslation();
  const steps = getOnboardSteps(t, onBoardStart);

  useEffect(() => {
    trackPageView({});
  }, []);

  return (
    <>
      <div className={style.reportPage}>
        <Header title={t('Downloads & Reports')} showLogo={true} />
        <div className={style.reportPageBody}>
          <div className={style.reportPageList}>
            {REPORT_ACTIONS.map(
              (report) =>
                (profileData?.customer.customer_id === 258 ||
                  ['exportAlertCounts'].indexOf(report.action) === -1) && (
                  <div key={report.action} className={style.reportPageReport}>
                    <Report report={report} />
                  </div>
                ),
            )}
            <Onboarding steps={steps} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Reports;
